<template>
  <div :class="['teacher-price-full', { 'w-full': isFullWidth }]">
    <div class="teacher-price-full__price">
      <span class="teacher-price-full__final">
        <span v-if="offPercent" class="teacher-price-full__before-discount">
          <span>{{ oldPrice }}</span>
        </span>
        <span :class="[finalPriceClass]" class="text-title">{{ currency }}</span>
        <span :class="[finalPriceClass]" class="text-title">{{ finalPrice }}</span>
      </span>
      <span class="teacher-price-full__time lg-block-hidden">
        {{ $t('common.labels.session_time_simple', {time: sessionTime}) }}
      </span>
      <span class="teacher-price-full__time lg-hidden-block">
        {{ $t('common.labels.session_time', {time: sessionTime}) }}
      </span>
    </div>
  </div>
</template>

<script>
import { currencySymbol } from '@helper/currencySymbol'

export default {
  name: 'TeacherPriceFull',
  inject: ['teacher'],
  props: {
    finalPriceClass: {
      type: String,
      default: 'text-body-1'
    },
    isFullWidth: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    finalPrice () {
      return this.teacher.teachingPrice?.final_price
    },
    oldPrice () {
      // return 25
      return this.teacher.teachingPrice?.old_price
    },
    offPercent () {
      // return 12
      return this.teacher.teachingPrice?.off_percent
    },
    sessionTime () {
      return this.teacher.teachingPrice?.session_time
    },
    currency () {
      return currencySymbol(this.teacher.teachingPrice?.currency)
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-price-full {
  @apply flex justify-center items-center;
  &__unit{
    @apply text-label-text;
  }
  &__before-discount {
    @apply text-error line-through lg:text__body-2-md--semibold text__body-2-xs--semibold;
  }
  &__price {
    @apply flex items-center space-x-2 flex-row lg:flex-col justify-center;
  }
  &__final {
    @apply text-title lg:text-body-1 lg:text__headline-5-md--bold text__headline-4-xs--bold
    flex items-center;
  }
  &__time {
    @apply text__caption-1-xs--regular lg:text__body-3-md--regular text-body-2;
  }
}
</style>
